<!-- 账号信息 -->
<template>
  <div id="accountCenter" class="fromPage">
    <!-- 页面标题 -->
    <div class="title_page">账号信息</div>
    <!-- 基础信息 -->
    <div class="form_detail">
      <div v-for="(item, i) in keyItems" :key="i">
        <div>{{ item.title }}</div>
        <div v-if="item.type == 'status'" class="nowrap" :class="item.class_status ? item.class_status[currentUser[item.key]] : ''">
          {{ item.text_status[currentUser[item.key]] ? item.text_status[currentUser[item.key]] : '--' }}
        </div>
        <div v-else-if="item.type == 'money'" class="nowrap">{{ `￥${common.formatNumber(currentUser[item.key])}` }}</div>
        <div v-else-if="item.type == 'time'" class="nowrap">{{ currentUser[item.key] ? moment(currentUser[item.key]).format('YYYY-MM-DD') : '--' }}</div>
        <div v-else-if="item.type == 'optBtn'" class="flexBetween" style="width: 75vh">
          <div>{{ item.param == 'pwd' ? '******' : currentUser[item.key] }}</div>
          <el-button type="text" @click="openDialog(item)">{{ item.optText }}</el-button>
        </div>
        <div v-else>{{ currentUser[item.key] ? currentUser[item.key] : '--' }}</div>
      </div>
      <!-- 专家-显示&编辑电子签名 -->
      <div v-if="currentUser.status == 1">
        <div>电子签名</div>
        <div class="flexBetween" style="width: 75vh">
          <div class="nowrap">
            <div v-if="currentUser.signature?.length > 0">
              <div v-for="(f, i) in currentUser.signature" :key="i" class="file nowrap" @click="handleFileViewing(f)">{{ f?.name }}</div>
            </div>
            <div v-else style="color: #909399">暂无附件</div>
          </div>
          <el-upload slot="append" class="upload-demo" :action="uploadUrl" :show-file-list="false" :http-request="uploadImg_signature">
            <el-button type="text">修改签名</el-button>
          </el-upload>
        </div>
      </div>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="70%" :close-on-click-modal="false">
      <div>
        <el-form v-if="dialogTitle == '修改密码'" :model="editForm" :rules="editRules_pwd" ref="editForm" label-width="100px" class="editForm">
          <el-form-item label="原始密码" prop="password">
            <el-input v-model="editForm.password" type="password" placeholder="请输入原始密码"></el-input>
          </el-form-item>
          <el-form-item label="新密码" prop="newPssword">
            <el-input v-model="editForm.newPssword" type="password" placeholder="请输入新密码"></el-input>
          </el-form-item>
          <el-form-item label="确认密码" prop="againPassword">
            <el-input v-model="editForm.againPassword" type="password" placeholder="请输入确认密码"></el-input>
          </el-form-item>
        </el-form>
        <el-form v-else :model="editForm" :rules="editRules_email" ref="editForm" label-width="100px" class="editForm">
          <el-form-item label="注册邮箱" prop="registerMail">
            <el-input v-model="editForm.registerMail" placeholder="请输入注册邮箱"></el-input>
          </el-form-item>
          <el-form-item label="新邮箱" prop="newEmail">
            <el-input v-model="editForm.newEmail" placeholder="请输入新邮箱"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitEdit('editForm')">确 定</el-button>
        <el-button @click="dialogVisible = false">取 消</el-button>
      </div>
      <div></div>
    </el-dialog>
    <!-- 预览组件 -->
    <PreviewFile ref="previewFile"></PreviewFile>
    <!-- 上传图片截图工具 -->
    <cropper ref="myCroppr" @emitt="callBack"></cropper>
  </div>
</template>
<script>
import moment from 'moment';
import PreviewFile from '../../../components/file-preview.vue';
import cropper from '../../../components/cropper.vue';
export default {
  name: 'accountCenter',
  components: { PreviewFile, cropper },
  data() {
    let checkPwd = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入您的密码'));
      } else {
        const reg = /^(\w){6,20}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error('密码由6-20个字母、数字、下划线组成，请重新输入'));
        }
      }
    };
    // 重复密码验证
    let pwdAgainCheck = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('重复密码不能为空'));
      } else {
        if (this.editForm.newPssword == this.editForm.againPassword) {
          callback();
        } else {
          return callback(new Error('两次输入密码不一致'));
        }
      }
    };
    return {
      moment: moment,
      uploadUrl: `${process.env.BASE_URL}api/file/upload`,
      // 信息字段
      keyItems: [
        { title: '用户名', key: 'registerMail' },
        { title: '密码', key: 'password', type: 'optBtn', optText: '修改密码', param: 'pwd' },
        { title: '邮箱', key: 'registerMail', type: 'optBtn', optText: '修改邮箱', param: 'email' },
        { title: '用户角色', key: 'status', type: 'status', text_status: ['管理员', '评审专家', '普通用户'] },
      ],
      // 弹窗
      dialogVisible: false,
      dialogTitle: '',
      editForm: {},
      editRules_pwd: {
        password: [{ required: true, message: '请输入原始密码', trigger: 'blur' }],
        newPssword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { validator: checkPwd, trigger: 'blur' },
        ],
        againPassword: [
          { required: true, message: '请输入确认密码', trigger: 'blur' },
          { validator: pwdAgainCheck, trigger: 'blur' },
        ],
      },
      editRules_email: {
        registerMail: [{ required: true, message: '请输入注册邮箱', trigger: 'blur' }],
        newEmail: [{ required: true, message: '请输入新邮箱', trigger: 'blur' }],
      },
    };
  },
  created() {
    this.$set(this.currentUser, 'status', 2);
    if (this.common.isLogin() == -1) {
      this.$set(this.currentUser, 'status', 0);
    } else if (this.common.isLogin() == -2) {
      this.$set(this.currentUser, 'status', 1);
    }
    if (this.currentUser.signature && this.currentUser.signature != '' && typeof this.currentUser.signature == 'string') {
      this.$set(this.currentUser, 'signature', JSON.parse(this.currentUser.signature));
    }
  },
  computed: {
    currentUser: function () {
      return this.$store.getters.getCurrentUser;
    },
    InnerWH: function () {
      return this.$store.getters.getInnerWH;
    },
  },
  methods: {
    openDialog(type) {
      this.dialogTitle = type.optText;
      if (type.param == 'pwd') {
        this.editForm = JSON.parse(JSON.stringify(this.editForm));
        this.$set(this.editForm, 'newPssword', '');
        this.$set(this.editForm, 'againPassword', '');
      } else {
        this.editForm = JSON.parse(JSON.stringify(this.editForm));
        this.$set(this.editForm, 'newEmail', '');
      }
      if (this.$refs['editForm']) {
        this.$refs['editForm'].resetFields();
      }
      this.dialogVisible = true;
    },
    // 编辑弹窗-提交
    submitEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$set(this.editForm, 'id', this.currentUser.id);
          let url = `${process.env.BASE_URL}api/login/passwordEdit`;
          if (this.dialogTitle.indexOf('邮箱') > 0) {
            url = `${process.env.BASE_URL}api//user/updateMail`;
            this.$set(this.editForm, 'userId', this.currentUser.id);
            this.$set(this.editForm, 'originalMail', this.editForm.registerMail);
            this.$set(this.editForm, 'mail', this.editForm.newEmail);
          }
          this.$axios
            .post(url, this.editForm)
            .then((res) => {
              if (res.data.code === 200) {
                this.$message({
                  showClose: true,
                  message: '修改成功',
                  offset: 80,
                  type: 'success',
                });
                if (this.dialogTitle.indexOf('邮箱') > 0) {
                  this.$set(this.currentUser, 'registerMail', this.editForm.newEmail);
                }
                this.dialogVisible = false;
              } else {
                this.$message({
                  showClose: true,
                  message: '修改失败-' + res.data.msg,
                  offset: 80,
                  type: 'error',
                });
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    // 预览
    handleFileViewing(file) {
      this.$refs.previewFile.openDrawer([file]);
    },
    uploadImg_signature(fileObj) {
      this.$refs.myCroppr.changeUpload(fileObj, 'signature');
    },
    // 图标上传回调
    callBack(data) {
      this.$axios
        .post(`${process.env.BASE_URL}api/user/updateSignature`, { id: this.currentUser.id, signature: JSON.stringify([{ name: data.name, url: data.url }]) })
        .then((res) => {
          if (res.data.code == 200) {
            this.$message({ message: `上传成功`, type: 'success' });
            this.$set(this.currentUser, 'signature', [{ name: data.name, url: data.url }]);
          } else {
            this.$message({
              message: res.data.msg,
              type: 'error',
            });
            this.$set(this.currentUser, 'signature', []);
          }
        })
        .catch((err) => {
          console.log(err);
          this.$set(this.currentUser, 'signature', []);
        });
    },
  },
};
</script>
<style lang="less" scoped>
.form_detail {
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: #f9fafb;
  margin-bottom: 45px;
  color: #111928;
  > div {
    display: flex;
    width: 100%;
    border-bottom: 1px solid #e5e7eb;
    > div {
      padding: 8px 15px;
    }
    > div:first-child {
      color: #6b7280;
      width: 10vh;
      position: relative;
      flex-shrink: 0;

      &::after {
        content: '';
        position: absolute;
        right: 0px;
        width: 2px;
        height: 60%;
        top: 20%;
        font-size: 20px;
        background: #e5e7eb;
      }
    }
    .file {
      text-decoration-line: underline;
      cursor: pointer;
    }
  }
}
</style>
